import script from "./MagneticWrap.vue?vue&type=script&setup=true&lang=js"
export * from "./MagneticWrap.vue?vue&type=script&setup=true&lang=js"

import "./MagneticWrap.vue?vue&type=style&index=0&id=05c271f8&scoped=true&lang=css"

import exportComponent from "/Users/yousefgadban/Developer/applates/applatesLandingVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05c271f8"]])

export default __exports__